import { Prisma, PrismaClient } from '@prisma/client';
import {
  fetchDroneDatabasesList,
  DroneDatabaseKeyType,
  fetchDashboardDatabasesList,
  DashboardDatabaseKeyType,
} from './databaseConstants';
import { DefaultArgs } from '@prisma/client/runtime/library';

const databaseUrl = process.env['RDS_DATABASE_URL'] as string;
function getTenantDatabaseUrl(dbName: DroneDatabaseKeyType | DashboardDatabaseKeyType): string {
  // return `${databaseUrl}/${dbName}?max_connections=10&sslmode=require`;
  return `${databaseUrl}/${dbName}?max_connections=10`;
}

export function createTenantPrismaClient(
  dbName: DroneDatabaseKeyType | DashboardDatabaseKeyType
): PrismaClient {
  const DATABASE_URL = getTenantDatabaseUrl(dbName);
  return new PrismaClient({
    datasources: {
      db: {
        url: DATABASE_URL,
      },
    },
  });
}

declare global {
  var prisma:
    | undefined
    | Map<
        DroneDatabaseKeyType | DashboardDatabaseKeyType,
        PrismaClient<Prisma.PrismaClientOptions, never, DefaultArgs>
      >;
}

const prisma = new Map<
  DroneDatabaseKeyType | DashboardDatabaseKeyType,
  ReturnType<typeof createTenantPrismaClient>
>();
if (!prisma.size && typeof window === 'undefined') {
  fetchDroneDatabasesList().then(({ droneSchool }) => {
    fetchDashboardDatabasesList().then(({ dashboard }) => {
      dashboard.forEach((databaseName: DashboardDatabaseKeyType) => {
        if (!prisma.get(databaseName)) {
          prisma.set(databaseName, createTenantPrismaClient(databaseName));
        }
      });
      droneSchool.forEach((databaseName: DroneDatabaseKeyType) => {
        if (!prisma.get(databaseName)) {
          prisma.set(databaseName, createTenantPrismaClient(databaseName));
        }
      });
    });
  });
}

export default prisma;

if (process.env.NODE_ENV !== 'production') globalThis.prisma = prisma;
